<script setup lang="ts">
// Field for a singular checkbox. Can also be used for multi-checkboxes.
// Tried to follow these docs in order to fix weird issues: https://vee-validate.logaretm.com/v4/examples/checkboxes-and-radio/

// TOOD: make this work with name="isPublished" where it emits true and false values

const {
  label = undefined,
  placeholder = undefined,
  isSubmitting = false,
  cols = 12,
  value = true,
  trueValue = true,
  falseValue = false, // if this is undefined, a boolean field doesn't work.
} = defineProps<{
  name: string
  label?: string
  placeholder?: string
  isSubmitting?: boolean
  cols?: number
  /** @default true.
   * The value of the checkbox when it's checked.
   * For multi-checkboxes, this should the value of the checkbox when it's checked.
   */
  value?: any
  /** @default undefined */
  trueValue?: any
  /** @default undefined. Note: if this is undefined, a boolean field doesn't work. */
  falseValue?: any
}>()
</script>

<template>
  <div :class="`col-span-${cols}`">
    <!-- :unchecked-value="false" -->
    <Field
      v-slot="{ field }"
      :name="name"
      :value="value"
      :unchecked-value="falseValue"
      type="checkbox"
    >
      <!-- why was the :dont-emit-value="true" again? -->
      <BaseCheckbox
        color="primary"
        v-bind="field"
        :label="label"
        :disabled="isSubmitting"
        :dont-emit-value="true"
        :true-value="trueValue"
        :false-value="falseValue"
        :value="value"
      />
      <!-- Uncomment for comparison against native checkbox when experiencing issues -->
      <!-- <label :for="name">
        <input
          type="checkbox"
          v-bind="field"
          :value="value"
        >
      </label> -->
    </Field>
  </div>
</template>
